import { SheetClose, SheetTitle } from '@/components/ui/sheet';
import { XMarkIcon } from '@heroicons/react/24/solid';

interface SheetCloseStickyProps {
  onClose: () => void;
  header?: string;
}
const SheetCloseSticky = ({ onClose, header }: SheetCloseStickyProps) => {
  return (
    <div className="sticky top-0 bg-white w-full border-b border-grey-50">
      <div className="p-5 flex justify-between items-center md:py-5 md:px-6 lg:py-6 lg:px-8">
        <SheetTitle className="text-base font-nunito700 text-grey-900 md:text-lg lg:text-xl">
          {header}
        </SheetTitle>
        <SheetClose
          onClick={onClose}
          className="focus:outline-hidden focus:ring-0 focus:ring-offset-0"
        >
          <XMarkIcon className="size-6 text-grey-900 cursor-pointer" />
        </SheetClose>
      </div>
    </div>
  );
};

export { SheetCloseSticky };
